export enum AD_UNIT_SECTION {
    TO_RENT = '/To-Rent',
    FOR_SALE = '/For-Sale',
    NEW_HOMES = '/New-Homes',
    HOUSE_PRICES = '/House-Prices',
    UNKNOWN = '/UNKNOWN',
    HOMEPAGE = '/'
}

export enum AD_UNIT_SECTION_NEW {
    TO_RENT = 'TR',
    FOR_SALE = 'FS',
    NEW_HOMES = 'NH',
    HOUSE_PRICES = 'HP',
    ESTATE_AGENTS = 'ES' /** currently only used in mason */,
    COMMERCIAL_PROPERTY_FOR_RENT = 'CPR' /** currently only used in LDP else mason */,
    COMMERCIAL_PROPERTY_FOR_SALE = 'CPS' /** currently only used in LDP else mason */,
    OVERSEAS = 'OS' /** currently only used in LDP else mason */,
    COMMUTE_TIME = 'CT' /** currently only used in mason */,
    HOMEPAGE = 'homepage',
    UNKNOWN = 'UNKNOWN'
}

export enum AD_UNIT_PAGE_TYPE {
    CHANNEL_LANDING_PAGE = 'CLP',
    LISTINGS_SEARCH_RESULT_PAGE = 'LSRP',
    LISTINGS_DETAILS_PAGE = 'LDP',
    PROPERTY_DETAILS_PAGE = 'PDP',
    AGENT_LISTING_PAGE = 'ADP' /** currently only used in mason */,
    OVERSEAS_BROWSE_PAGE = 'OBP' /** currently only used in mason */,
    UNKNOWN = 'UNKNOWN',
    HOMEPAGE = 'homepage'
}

export enum ADBRIDG_CLASS {
    TEXT_LINK_LSRP = 'text_link_lsrp',
    MPU = 'mpu',
    VALUATION_BOOSTER = 'valuation_booster',
    MPU_2 = 'mpu2',
    SKYSCRAPER = 'skyscraper',
    SKYSCRAPER_2 = 'skyscraper2',
    INTERSTITIAL_DESKTOP = 'interstitial_desktop',
    INTERSTITIAL_MOBILE = 'interstitial_mobile',
    SPONSOR_MOBILE = 'sponsor_mobile',
    TEXT_LINK_LDP = 'text_link_ldp',
    SPONSOR_DESKTOP = 'sponsor_desktop',
    TEXT_LINK_MH = 'text_link_mh',
    TEXT_LINK = 'text_link',
    INLINE_SPECIAL = 'inline_special',
    ADB_FLUID = 'adb-fluid',
    ADB_TEXT_LINK = 'adb-text-link',
    ADB_SPECIAL_BANNER = 'adb-special-banner',
    ADB_HP_SPECIAL_BANNER = 'adb-hp-special-banner'
}

type MediaQueryDirection = '>' | '<';
export type Breakpoint = [MediaQueryDirection, number];

export type GoogleTag = any; // eslint-disable-line @typescript-eslint/no-explicit-any
export type AdBridg = any; // eslint-disable-line @typescript-eslint/no-explicit-any

export type CustomWindow = Window &
    typeof globalThis & {
        googletag: GoogleTag;
        AdBridg: AdBridg;
    };

export enum ADBRIDG_ACTION {
    SHUTDOWN = 'spa_pv_shutdown',
    INITIALISE = 'spa_pv_initialize'
}

export type Targeting = { [key: string]: string | string[] };
